export var DEFAULT_MOBILE_PROPS = {
  columns: 1,
  rows: 1,
  stackable: true,
  displayAll: false
};
export var DEFAULT_TABLET_PROPS = {
  columns: null,
  rows: null,
  doubling: false,
  displayAll: false
};
export var DEFAULT_INFINITE_SCROLL_ENABLED = false;
export var DEFAULT_PAGINATION_PROPS = {
  display: true,
  onlyPageIndicators: false,
  defaultActivePage: 1,
  directionIndicatorIcons: {},
  infiniteScroll: {
    enabled: DEFAULT_INFINITE_SCROLL_ENABLED,
    showMoreButtonProps: {}
  }
};